import createI18n from '@/lib/i18next/createI18n';

export let i18n = {};

// innerT is synchronously access in components.
// this is a dummy placeholder that wont be called and will be
// replaced by a blocking setup call during app initialize
let innerT = function(str) {
  return str;
};

export async function setup() {
  innerT = await window.globalLibs.i18NextPromise;
  i18n = { t: innerT };
}

export default function t(strText, ...tail) {
  const spTranslated =
    typeof window._sp === 'function' ? window._sp(strText) : strText;
  return innerT(spTranslated, ...tail);
}

export function useI18n() {
  return innerT;
}

/**
 * @param{Object} p
 *  @param{String} p.module
 *  @param{String} p.file
 *  @param{String} p.app // add app translation support
 *
 * @return{Function}
 */
export function getTranslations({ module = '', file = '', app = '' }) {
  if (!file) {
    throw new Error('file name is required');
  }

  function translation(translationKey, ...vars) {
    return innerT(
      `${app ? `apps:${app}:` : ''}${
        module ? `${module}:` : ''
      }${file}:${translationKey}`,
      ...vars
    );
  }

  return translation;
}

export async function changeLanguage(languageCode) {
  await createI18n();
  await window.i18nInstance.changeLanguage(languageCode);
}
